import React from "react";
import utils from "../../modules/utils";
import Stepper from "../shared/stepper.js";
import Spinner from "../shared/spinner.js";
import moment from 'moment';
import axios from "axios";
import ModalError from "../shared/modal_errore.js";
import apiInvoker from "../../modules/apiInvoker";
import { clearHistoryBack } from "../../actions/index";
import { connect } from "react-redux";
import { trackPageView } from "../../modules/datalayer.js";
import { setDatiPersonali, setConsensi, clearConsensi } from "../../actions/index";
import FormRadioButton from "../dati_personali/components/FormRadioButton/index";
import "../dati_personali/dati_personali.css";
import "./contact_center.css";
/* Flow */
import { handleFlow } from '../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {
    setDatiPersonali: type => dispatch(setDatiPersonali(type)),
    setConsensi: type => dispatch(setConsensi(type)),
    clearHistoryBack: c => dispatch(clearHistoryBack(c)),
    clearConsensi: c => dispatch(clearConsensi(c)),
  };
};

class DatiPersonaliContactCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'nome': '',
      'cognome': '',
      'email': '',
      'telefono': '',
      'cap': '',
      'orario': '0',
      'impiego': '',
      'informativa': '',
      'dati_personali': '',
      'valutazione': '',
      'societa_terze': '',
      'loading': false,
      'errors': {}
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    trackPageView("dati-personali");
    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    utils.animate.zoomIn();
    this.props.clearHistoryBack();
  }
  handleInputChange(e) {
    let self = this;
    let errors = self.state.errors;
    const input = e.currentTarget;
    const validationsStr = input.getAttribute('data-validation');
    const validations = validationsStr.split("|");
    let errorMessage = "";

    let new_value = input.value;
    if (input.name == 'email' || input.name == 'telefono' || input.name == 'cap') {
      new_value = new_value.trim();
    }

    for (let v in validations) {
      const validation = validations[v];
      if (validation == 'required') {
        if (!self.validateRequired(input.value)) {
          errorMessage = "Campo obbligatorio (min. 2 caratteri)";
        }
      } else if (validation == 'email') {
        if (!self.validateEmail(new_value)) {
          errorMessage = "Formato email non corretto";
        }
      } else if (validation == 'phone') {
        if (!self.validatePhone(new_value)) {
          errorMessage = "Formato telefono non corretto";
        }
      } else if (validation == 'only-text') {
        if (!self.validateOnlyText(input.value)) {
          errorMessage = "Inserire solo caratteri alfabetici";
        }
      } else if (validation == 'cap') {
        if (!self.validateCap(new_value)) {
          errorMessage = "Formato cap non corretto";
        }
      }
    }
    errors[input.name] = errorMessage;
    let field = {};
    field[input.name] = new_value;
    this.setState(field);
  }
  handleRadio(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    radio.checked = true;
    let errors = this.state.errors;
    delete errors[radio.name];
    this.setState({
      [radio.name]: radio.value == 1 ? true : false,
      errors: errors
    });
  }
  handleCheck(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    let value;
    let errors = this.state.errors;

    radio.checked = true;
    delete errors[radio.name];

    switch (radio.value) {
      case "true":
        value = true;
        break;
      case "false":
        value = false;
        break;
      default:
        value = radio.value;
    }

    this.setState({
      [radio.name]: value,
      errors: errors
    });
  }
  handleSelectChange(e) {
    const input = e.currentTarget;
    let field = {};
    console.log(input.value);
    field[input.name] = input.value;
    this.setState(field);
  }
  validateRequired(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      valid = true;
    }
    return valid;
  }

  validateOnlyText(val) {
    let valid = false;
    if (val && typeof val == "string" && val.length > 1) {
      var re = /[^0-9]$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateEmail(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateRb(key) {
    return (
      document.querySelectorAll('input[name="' + key + '"]:checked').length > 0
    );
  }

  validatePhone(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var re = /^[0-9]{8,11}$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateCap(val) {
    let valid = false;
    if (
      val &&
      val &&
      typeof val == "string" &&
      val.length > 1 &&
      Number(val) >= 10 && Number(val) <= 98168
    ) {
      var re = /^[0-9]{5}$/;
      valid = re.test(String(val).toLowerCase());
      const global_state = utils.getState();
      if (global_state.prodotto == 3 || global_state.prodotto == 5) {
        valid = val.length > 2;
      }
    }
    return valid;
  }
  validateForm() {
    let valid = true;
    let errors = {};
    const global_state = utils.getState();
    if (this.state.informativa==='') {
      valid = false;
      errors['informativa'] = 'Seleziona un\'opzione';
    }
    if (this.state.dati_personali === '') {
      valid = false;
      errors['dati_personali'] = 'Seleziona un\'opzione';
    }
    if (this.state.societa_terze === '') {
      valid = false;
      errors['societa_terze'] = 'Seleziona un\'opzione';
    }
    if (!global_state.found_db_compass) {
      if (this.state.valutazione === '' || this.state.valutazione === false) {
        valid = false;
        errors['valutazione'] = 'il consenso è obbligatorio per il prosieguo del processo';
      }
    }
    if (!this.validateRequired(this.state.nome)) {
      valid = false;
      errors['nome'] = 'Campo obbligatorio (min. 3 caratteri)';
    }
    if (!this.validateOnlyText(this.state.nome)) {
      valid = false;
      errors['nome'] = 'Inserire solo caratteri alfabetici';
    }
    if (!this.validateRequired(this.state.cognome)) {
      valid = false;
      errors['cognome'] = 'Campo obbligatorio (min. 3 caratteri)';
    }
    if (!this.validateOnlyText(this.state.cognome)) {
      valid = false;
      errors['cognome'] = 'Inserire solo caratteri alfabetici';
    }
    if (!this.validateEmail(this.state.email)) {
      valid = false;
      errors['email'] = 'Formato email non corretto';
    }
    if (!this.validatePhone(this.state.telefono)) {
      valid = false;
      errors['telefono'] = 'Formato telefono non corretto';
    }
    if (!this.validateCap(this.state.cap)) {
      valid = false;
      errors['cap'] = 'Formato cap non corretto';
    }
    if (document.querySelectorAll("[name='impiego']:checked").length==0) {
      valid = false;
      errors['impiego'] = 'Seleziona un valore';
    }
    if (!valid) {
      this.setState({
        'errors': errors
      })
    }
    return valid;
  }
  handleSubmit(e) {
    e.preventDefault();
    let self = this;
    self.setState({
      loading: true
    });

    const formValid = self.validateForm();
    if (formValid) {

      //Imposto il global state
      self.props.setDatiPersonali({
        nome: self.state.nome,
        cognome: self.state.cognome,
        email: self.state.email,
        telefono: self.state.telefono,
        cap: self.state.cap,
        provincia: 'provincia',
        comune: 'comune',
        impiego: self.state.impiego,
      })
      self.props.setConsensi({
        informativa: self.state.informativa,
        dati_personali: self.state.dati_personali,
        societa_terze: self.state.societa_terze
      });


      const global_state = utils.getState();

      let utm_term = window.printParam("utm_term");
      if ((!utm_term || utm_term == "") && global_state.prodotto != 3) {
        utm_term = "Nuovo fissa appuntamento";
      }

      let consenso_valutazione = self.state.valutazione ? 1 : 0;
      if (global_state.found_db_compass) {
        consenso_valutazione = 1;
      }

      //Dati chiamata
      const body = {
        filiale: global_state.id_filiale,
        data: moment().add(1, 'days').format('YYYY-MM-DD'),
        nome: self.state.nome,
        cognome: self.state.cognome,
        email: self.state.email,
        cellulare: self.state.telefono,
        capResidenza: self.state.cap,
        fasciaoraria: self.state.orario,
        provinciaResidenza: '',
        comuneResidenza: '',
        codiceFiscale: global_state.utente.codice_fiscale,
        privacyExtcommoffer: self.state.informativa ? 1 : 0,
        privacyProfilazione: self.state.societa_terze ? 1 : 0,
        privacyOtherservice: self.state.dati_personali ? 1 : 0,
        privacyInterncommoffer: consenso_valutazione,
        valutazione: consenso_valutazione, //Retrocompatibilità
        tipoOccupazione: self.state.impiego,
        iscrittoCameraCommercio: '',
        tipoAzienda: '',
        oppID: '',
        prodotto: global_state.prodotto,
        iscrittoCameraCommercio: false,
        tipoAzienda: '',
        PosizioneCliente: global_state.coordinate_luogo,
        utm_source: window.printParam("utm_source"),
        utm_medium: window.printParam("utm_medium"),
        utm_campaign: window.printParam("utm_campaign"),
        utm_date: window.printParam("utm_date"),
        utm_history: window.printParam("utm_history"), //Gestito da trackingManager
        utm_content: window.printParam("utm_content"),
        utm_term: utm_term,
        mediacode: window.printParam("mediacode"), //Gestito da trackingManager
        source: global_state.source
      };

      apiInvoker.CreaAppuntamentoAsync(
        body,
        res => {
          self.setState({
            loading: false
          });
          if (res.status == 200) {
            const ws_result = res.data;
            const tracking_url = ws_result.trackingUrl || "";
            if (ws_result.codRes == 0) {
              if (tracking_url != "") {
                axios.get(tracking_url);
              }

              handleFlow();
            }
          }
        },
        err => {
          console.log(err);
          if (global_state.prodotto == 3 || global_state.prodotto == 5) {
            document
              .querySelector('button[type="submit"]')
              .removeAttribute("disabled");
          }
          self.props.clearConsensi();
          self.setState({
            loading: false
          });
          utils.showErrorModal("Errore generico, riprova tra poco.");
        }
      );
    } else {
      self.setState({
        loading: false
      });
    }
  }

  render() {
    const global_state = utils.getState();
    let privacy = (
      <div>
        <h2>Un’ultima cosa: abbiamo bisogno del tuo consenso per fissare un appuntamento e valutare l’eventuale richiesta di credito.</h2>
        <div>
          <h3>
            Esprimi il tuo consenso al trattamento dei dati<br />
            <br />
            Prendi visione delle informative rese da Compass <span className="red-text">ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679</span>,
            della normativa nazionale vigente in materia di protezione dei dati personali e del Codice di condotta per
            i sistemi informativi gestiti da soggetti privati in materia di crediti
                            al consumo affidabilità e puntualità nei pagamenti <a href="/fissa-appuntamento/pdf/COM257F_04_20.pdf" target="_blank">qui scaricabili</a>
          </h3>
          <RadioConsensi
            name="informativa"
            value={this.state.informativa}
            handler={this.handleRadio}
            error={this.state.errors["informativa"]}
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali,
            ivi inclusi i dati relativi all'andamento dei rapporti e i dati relativi all'esposizione
            anche nei confronti delle società del Gruppo Mediobanca, siano trattati da Compass Banca S.p.A
            e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi),
                          per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.<br />
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza.
                        </p>
          <RadioConsensi
            name="dati_personali"
            value={this.state.dati_personali}
            handler={this.handleRadio}
            error={this.state.errors["dati_personali"]}
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano trattati da Compass,
            per la finalità di cui alla lettera e), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze,
            gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o
            servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni
            a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
                        </p>
          <RadioConsensi
            name="societa_terze"
            value={this.state.societa_terze}
            handler={this.handleRadio}
            error={this.state.errors["societa_terze"]}
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano comunicati a
            e trattati da Società terze per la finalità indicata alla lettera c) per prodotti o servizi da queste ultime offerti.
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui
            ciò è prescritto dalle disposizioni di vigilanza
                        </p>
          <RadioConsensi
            name="valutazione"
            value={this.state.valutazione}
            handler={this.handleRadio}
            error={this.state.errors["valutazione"]}
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali, ivi inclusi quelli particolari,
            siano trattati da Compass Banca S.p.A. e comunicati a terzi (e da questi trattati), per le finalità ivi indicate alle lettere
            a) e d) e che Compass acquisisca dalle Società del Gruppo Mediobanca, che quindi potranno trasmettere, i dati relativi
            all'andamento dei rapporti eventualmente intercorrenti con queste ultime e li tratti per finalità strettamente connesse
            alla valutazione del merito creditizio della presente richiesta o per la valutazione di un nuovo rapporto.
                        </p>
        </div>  
      </div>
    );

    if (global_state.found_db_compass) { //Utente trovato nelle liste compass
      privacy = (
        <div>
          <h3>
            Prendi visione della informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati personali <a href="/fissa-appuntamento/pdf/Privacy_FA_12_21.pdf" target="_blank">qui scaricabili</a>
        </h3>
          <RadioConsensi
            name="informativa"
            value={this.state.informativa}
            handler={this.handleRadio}
            error={this.state.errors["informativa"]}
          />
          <p>
            dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali, siano trattati da Compass Banca S.p.A e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi), per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.
  Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza
          </p>
          <RadioConsensi
            name="dati_personali"
            value={this.state.dati_personali}
            handler={this.handleRadio}
            error={this.state.errors["dati_personali"]}
          />
          <p>
            dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali siano trattati da Compass, per la finalità di cui alla lettera c), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze, gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
          </p>
          <RadioConsensi
            name="societa_terze"
            value={this.state.societa_terze}
            handler={this.handleRadio}
            error={this.state.errors["societa_terze"]}
          />
          <p>
            dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali siano comunicati a e trattati da Società terze per la finalità indicata alla lettera b) per prodotti o servizi da queste ultime offerti. Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui ciò è prescritto dalle disposizioni di vigilanza
          </p>
        </div>
      );
    }

    return (
      <div id="dati_personali">
        <Stepper percentage="80" />
        <ModalError />
        <Spinner visible={this.state.loading} />
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <div className="panel gsap-slide">
                <form onSubmit={this.handleSubmit} id="form-dati-personali">
                  <h2 className="topEl">Inserisci i tuoi riferimenti</h2>

                  <div className="grid-container container-input-dati-personali">
                    <div className="grid-x grid-padding-x">
                      <div className="cell medium-6">
                        <div className={"inputContainer " + (this.state.nome != '' ? 'filled' : '') + " " + ((this.state.errors.nome && this.state.errors.nome != '') ? 'notValid' : '') + " " + (((!this.state.errors.nome || this.state.errors.nome == '') && this.state.nome != '') ? 'valid' : '')}>
                          <input type="text" data-validation="required|only-text" name="nome" value={this.state.nome} onChange={this.handleInputChange} autoComplete="off" />
                          <label>Nome*</label>
                          <div className="error">{this.state.errors.nome}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                      <div className="cell medium-6">
                        <div className={"inputContainer " + (this.state.cognome != '' ? 'filled' : '') + " " + ((this.state.errors.cognome && this.state.errors.cognome != '') ? 'notValid' : '') + " " + (((!this.state.errors.cognome || this.state.errors.cognome == '') && this.state.cognome != '') ? 'valid' : '')}>
                          <input type="text" data-validation="required|only-text" name="cognome" value={this.state.cognome} onChange={this.handleInputChange} autoComplete="off" />
                          <label>Cognome*</label>
                          <div className="error">{this.state.errors.cognome}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                      <div className="cell medium-6">
                        <div className={"inputContainer " + (this.state.email != '' ? 'filled' : '') + " " + ((this.state.errors.email && this.state.errors.email != '') ? 'notValid' : '') + " " + (((!this.state.errors.email || this.state.errors.email == '') && this.state.email != '') ? 'valid' : '')}>
                          <input type="text" data-validation="required|email" name="email" value={this.state.email} onChange={this.handleInputChange} autoComplete="off" />
                          <label>Email*</label>
                          <div className="error">{this.state.errors.email}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                      <div className="cell medium-6">
                        <div className={"inputContainer " + (this.state.telefono != '' ? 'filled' : '') + " " + ((this.state.errors.telefono && this.state.errors.telefono != '') ? 'notValid' : '') + " " + (((!this.state.errors.telefono || this.state.errors.telefono == '') && this.state.telefono != '') ? 'valid' : '')}>
                          <input type="text" data-validation="required|phone" name="telefono" value={this.state.telefono} onChange={this.handleInputChange} autoComplete="off" />
                          <label>Telefono*</label>
                          <div className="error">{this.state.errors.telefono}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                      <div className="cell medium-6">
                        <div className={"inputContainer " + (this.state.cap != '' ? 'filled' : '') + " " + ((this.state.errors.cap && this.state.errors.cap != '') ? 'notValid' : '') + " " + (((!this.state.errors.cap || this.state.errors.cap == '') && this.state.cap != '') ? 'valid' : '')}>
                          <input type="text" data-validation="required|cap" name="cap" value={this.state.cap} onChange={this.handleInputChange} autoComplete="off" />
                          <label>Cap*</label>
                          <div className="error">{this.state.errors.cap}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                      <div className="cell medium-6">
                        <div className={"inputContainer selectInputContainer " + (this.state.orario != '' ? 'filled' : '') + " " + (((!this.state.errors.orario || this.state.errors.orario == '') && this.state.orario != '') ? 'valid' : '')}>
                          <select name="orario" onChange={this.handleSelectChange}>
                            <option value="0">Indifferente</option>
                            <option value="1">Mattino</option>
                            <option value="2">Pomeriggio</option>
                          </select>
                          <label>Preferenza orario*</label>
                          <div className="error">{this.state.errors.orario}</div>
                          <div className="icon">
                            <img src="./img/check.png" alt="Verificato" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h2 id="impiegoContact">Che tipo di impiego hai?</h2>
                  <div className="grid-container">
                    <div className="grid-x grid-padding-x">
                      <div className="cell medium-6 medium-offset-3">
                        <div className="grid-x grid-padding-x" id="radio-impiego">
                          <div className={"cell medium-6"}>
                            <FormRadioButton
                              handler={this.handleCheck}
                              validate="rb"
                              name="impiego"
                              label="Dipendente"
                              value="2"
                            />
                          </div>
                          <div className={"cell medium-6"}>
                            <FormRadioButton
                              handler={this.handleCheck}
                              validate="rb"
                              name="impiego"
                              label="Autonomo"
                              value="1"
                            />
                          </div>
                          <div className={"cell medium-6"}>
                            <FormRadioButton
                              handler={this.handleCheck}
                              validate="rb"
                              name="impiego"
                              label="Pensionato"
                              value="3"
                            />
                          </div>
                          <div className={"cell medium-6"}>
                            <FormRadioButton
                              handler={this.handleCheck}
                              validate="rb"
                              name="impiego"
                              label="Altro"
                              value="4"
                            />
                          </div>
                          <div className="error">{this.state.errors["impiego"]}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="privacyCompressor">
                    {privacy}
                  </div>
                  <button type="submit" className="bottone">
                    fissa appuntamento
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class RadioConsensi extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const validField = !(typeof this.props.error != "undefined" && this.props.error != "");
    const validClass = !validField ? " notValid" : " valid";
    const classFintoErrore = 'fintoErrore ' + ((this.props.name == 'valutazione' && (!this.props.error || this.props.error=="")) ? '' : 'hidden');
    return (
      <React.Fragment>
        <div className={ "multiradioContainer" + validClass } >
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} value="1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Acconsento</label>
          </div>
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} value="-1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Non acconsento</label>
          </div>
        </div>
        <div className={classFintoErrore}> 
          il consenso è obbligatorio per il prosieguo del processo
        </div>
        <div className="error">
          {!validField ? this.props.error : ""}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(null, mapDispatchToProps)(DatiPersonaliContactCenter);



// WEBPACK FOOTER //
// ./src/components/dati_contact_center/index.js